module.exports = __webpack_public_path__ + "img/img-24h.b7bead73.svg";